export default {
    add_all_materials_from_warehouse: "Stokdagi barcha materiallarni qo'shing",
    add_good: "Mahsulot qo'shing",
    add_material: "Material qo‘shish",
    add_new: "Yangi qo‘shish",
    adding_new_supplier: "Yangi yetkazib beruvchi qo‘shish",
    addition: "Kirim",
    address: "Manzil",
    adjustment: "Tuzatish",
    amount: "Miqdor",
    amount_of_stock_on_all_warehouses: "Klinikaning barcha omborlarida mavjud bo‘lgan tovarlarning umumiy miqdori",
    approve: "O‘tkazish",
    approved: "O‘tkazilgan",
    are_you_sure_you_want_to_delete_group: "Haqiqatan ham guruhni o‘chirmoqchimisiz?",
    are_you_sure_you_want_to_delete_kit: "Haqiqatan ham to‘plamnini o‘chirmoqchimisiz?",
    are_you_sure_you_want_to_delete_supplier: "Haqiqatan ham yetkazib beruvchini o‘chirmoqchimisiz?",
    are_you_sure_you_want_to_delete_warehouse: "Haqiqatan ham omborni o‘chirmoqchimisiz?",
    artikul: "Artikul",
    available_for_sale: "Sotuv uchun mavjud",
    bank_requisites: "Bank rekvizitlari",
    barcode: "Shtrixkod",
    beginning_balance: "Boshlang‘ich qoldiq",
    bin: "BIN",
    branch: "Filial",
    bulk_addition: "Guruh bo'yicha qo'shing",
    by_categories: "Kategoriya bo'yicha",
    consumption: "Chiqim",
    consumption_manual: "Qo‘shimcha chiqim",
    contact_person: "Aloqa qiluvchi shaxs",
    contragent: "Taqdimot",
    cost: "Qiymat",
    created: "Yaratilgan",
    current_stock: "Joriy qoldiq",
    default_for_sale: "Mahsulotlarni sotish uchun standart foydalaning",
    default_for_writeoff: "Moddiy yozish uchun standart foydalaning",
    destination: "Ko‘rsatma",
    details: "Tafsilotlar",
    difference: "Divergentsiya",
    documents: "Hujjatlar",
    draft: "Qoralama",
    enter_title_or_barcode: "Nom yoki shtrix kodni kiriting",
    factual_amount: "Haqiqatan ham miqdor",
    finished: "O‘tkazildi",
    finished2: "Bajarildi",
    found_similar_material: "O'xshash material topildi",
    from: "dan",
    from_warehouse: "Ombordan o'tkazish",
    from_where: "Qayerdan",
    general_price: "Umumiy summa",
    general_stock: "Umumiy qoldiq",
    group: "Guruh",
    groups: "Guruhlar",
    id: "Id",
    in_warehouse: "Omborda",
    inventarization: "Inventarizasiya",
    kit: "To‘plam",
    Kit: "To‘plam",
    kits: "To‘plamlar",
    material: "Material",
    materialgroup: "Guruh",
    materials: "Materiallar",
    materialstock: "Material",
    movement: "Joy o‘zgarishi",
    movement_from: "Joy o‘zgarishi",
    movement_to: "Joy o‘zgarishi",
    movements: "Harakatlar",
    nomenclature: "Nomenklatura",
    not_enough_material: "Material yetarli emas",
    notify_when_stock: "Qoldiq haqida xabar berish",
    on_visit_close: "Tashrifni yopayotganda",
    on_visit_save: "Tashrifni saqlashda",
    operation: "Operasiya",
    parent_category: "Ota kategoriya",
    parent_group: "Ota-onalar guruhi",
    physical: "Jismoniy",
    price_will_be_used_automatically_from_addition: "Narx kvitansiya hujjatidan avtomatik ravishda qo'llaniladi",
    print: "Bosib chiqarish",
    prohibit_minus_stocks: "Materiallarni manfiy qoldiqga yozishni taqiqlash",
    prohibit_minus_stocks_in_warehouse_documents: "Ushbu parametr \"Ombor\" bo'limida hujjatlarni to'ldirishda materiallarni minus sifatida hisobdan chiqarishni taqiqlaydi",
    prohibit_minus_stocks_on_visit_closing: "Tashrif materiallarini minus sifatida hisobdan chiqarishni taqiqlash (tashrifni yakunlashni taqiqlash)",
    purchase_price: "Xarid narxi",
    return: "Qaytarish",
    returns: "Qaytarishlar",
    sale_of_goods_refund: "Sotilgan tovarlarni qaytarish",
    sale_price: "Sotish narxi",
    stocks: "Qoldiqlar",
    stocks_archive: "Materiallar arxivi",
    supplier: "Yetkazib beruvchi",
    suppliers: "Yetkazib beruvchilar",
    to_warehouse: "Omborga o'tkazish",
    to_where: "Qayerga",
    trying_to_writeoff: "Hisobdan chiqarishga harakat qiling",
    type: "Тur",
    unit_of_measure: "O‘l./bir.",
    virtual: "Virtual",
    warehouse_amount: "Stokdagi miqdor",
    warehouseoperation: "Operasiyalar",
    warehouses: "Omborlar",
    write_off: "Hisobdan chiqarish",
    write_off_materials: "Materiallarni yozing"
}
